export default __webpack_public_path__ + "410791537c484b1201d94189a32562e3.svg";